/* eslint no-unused-expressions: 0 */
/* eslint no-undef: 0 */
/* eslint no-restricted-globals: 0 */
!(function () {
  function a(b, c, d) {
    function e(g, h) {
      if (!c[g]) {
        if (!b[g]) {
          var i = "function" == typeof require && require;
          if (!h && i) return i(g, !0);
          if (f) return f(g, !0);
          var j = new Error("Cannot find module '" + g + "'");
          throw ((j.code = "MODULE_NOT_FOUND"), j);
        }
        var k = (c[g] = { exports: {} });
        b[g][0].call(
          k.exports,
          function (a) {
            var c = b[g][1][a];
            return e(c || a);
          },
          k,
          k.exports,
          a,
          b,
          c,
          d
        );
      }
      return c[g].exports;
    }
    for (
      var f = "function" == typeof require && require, g = 0;
      g < d.length;
      g++
    )
      e(d[g]);
    return e;
  }
  return a;
})()(
  {
    1: [
      function (a, b, c) {
        "use strict";
        function d(a) {
          return (d =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (a) {
                  return typeof a;
                }
              : function (a) {
                  return a &&
                    "function" == typeof Symbol &&
                    a.constructor === Symbol &&
                    a !== Symbol.prototype
                    ? "symbol"
                    : typeof a;
                })(a);
        }
        function e(a) {
          for (var b = 1; b < arguments.length; b++) {
            var c = null != arguments[b] ? arguments[b] : {},
              d = Object.keys(c);
            "function" == typeof Object.getOwnPropertySymbols &&
              (d = d.concat(
                Object.getOwnPropertySymbols(c).filter(function (a) {
                  return Object.getOwnPropertyDescriptor(c, a).enumerable;
                })
              )),
              d.forEach(function (b) {
                f(a, b, c[b]);
              });
          }
          return a;
        }
        function f(a, b, c) {
          return (
            b in a
              ? Object.defineProperty(a, b, {
                  value: c,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (a[b] = c),
            a
          );
        }
        function g(a, b) {
          var c = document.createElement("link");
          "font" === b &&
            ((c.type = "font/" + a.split(".").pop()),
            (c.crossOrigin = "anonymous")),
            (c.as = b),
            (c.rel = "preload"),
            (c.href = a),
            document.body.appendChild(c);
        }
        function h() {
          n.map(function (a) {
            g(a, "fetch");
          });
        }
        var i = a("./EcsterPayCommunicator"),
          j = a("@ecster/logging"),
          k = function () {
            var a = window.location,
              b =
                (a.hostname,
                a.protocol + "//" + a.hostname + (a.port ? ":" + a.port : ""),
                "none");
            return (b = "https://secure.ecster.se/pay");
          },
          l = function () {
            for (var a = [], b = 0; b < 256; b++)
              a[b] = (b < 16 ? "0" : "") + b.toString(16);
            var c = this,
              f = !1,
              g = null,
              h = "ecster-pay",
              l = "ecster-pay-fullscreen",
              m = "ecster-pay-ctr",
              n = function () {
                if (!document.getElementById(l)) {
                  var a = document.createElement("iframe");
                  a.setAttribute("src", c.checkoutUrl + "/index-fs.html"),
                    (a.frameBorder = 0),
                    (a.id = l),
                    (a.style.cssText =
                      "position: fixed; height: 0; width: 100%;top: 0; left: 0; opacity: 0; transition: opacity 0.3s ease-in; z-index: 2147483647; -webkit-backface-visibility:hidden;"),
                    (a.onload = function () {
                      i.startFullscreenCommunicator(
                        a.contentWindow,
                        c.checkoutUrl + "/index-fs.html"
                      ),
                        i.addHandler("fullscreen-show-content", function (b) {
                          (a.style.opacity = "1"),
                            (a.style.height = "100%"),
                            i.sendMessage("fullscreen-show-content", {
                              type: b.type,
                              message: b.message,
                              closeText: b.closeText,
                            });
                        }),
                        i.addHandler("ep-fullscreen-hide", function (b) {
                          (a.style.opacity = "0"), (a.style.height = "0");
                        });
                    }),
                    document.body.appendChild(a);
                }
              },
              o = function (a, b, d, e, f) {
                var j = document.createElement("iframe");
                (j.className = "ecster-pay"),
                  (j.frameBorder = 0),
                  (j.width = d),
                  (j.height = e),
                  (j.id = h),
                  j.setAttribute(
                    "src",
                    c.checkoutUrl +
                      "/?v=" +
                      Math.floor(new Date().getTime() / 1e3 / 60)
                  ),
                  (j.scrolling = f || "no"),
                  (j.onload = function () {
                    i.startCommunication(j.contentWindow, c.checkoutUrl, a),
                      i.addHandler("ep-iframe-height", function (a) {
                        j.style.height = a && a.height ? a.height : "400px";
                      });
                  }),
                  (g = j),
                  b.appendChild(j);
              },
              p = function () {
                var a = setInterval(function () {
                  var b,
                    d,
                    e = document.getElementById(m);
                  e
                    ? ((d = e.getBoundingClientRect().top),
                      c.checkoutTopValue !== d &&
                        ((b = d > 0 ? 10 : -d + 10),
                        i.sendMessage("checkout-top-offset", { topOffset: b }),
                        (c.checkoutTopValue = d)))
                    : clearInterval(a);
                }, 300);
              },
              q = function (a) {
                var b;
                document.getElementById(h) ||
                  ((c.checkoutTopValue = document
                    .getElementById(m)
                    .getBoundingClientRect().top),
                  (b = document.getElementById(m)),
                  o(a, b, "100%", "820px"),
                  p());
              },
              r = function (a, b, c) {
                var d = "";
                if (c) {
                  var e = new Date();
                  e.setTime(e.getTime() + 24 * c * 60 * 60 * 1e3),
                    (d = "; expires=" + e.toUTCString());
                }
                document.cookie = a + "=" + b + d + "; path=/";
              },
              s = function (a) {
                for (
                  var b = a + "=", c = document.cookie.split(";"), d = 0;
                  d < c.length;
                  d++
                ) {
                  for (var e = c[d]; " " === e.charAt(0); )
                    e = e.substring(1, e.length);
                  if (0 === e.indexOf(b))
                    return e.substring(b.length, e.length);
                }
                return null;
              },
              t = function () {
                var b = (4294967295 * Math.random()) | 0,
                  c = (4294967295 * Math.random()) | 0,
                  d = (4294967295 * Math.random()) | 0,
                  e = (4294967295 * Math.random()) | 0;
                return (
                  a[255 & b] +
                  a[(b >> 8) & 255] +
                  a[(b >> 16) & 255] +
                  a[(b >> 24) & 255] +
                  "-" +
                  a[255 & c] +
                  a[(c >> 8) & 255] +
                  "-" +
                  a[((c >> 16) & 15) | 64] +
                  a[(c >> 24) & 255] +
                  "-" +
                  a[(63 & d) | 128] +
                  a[(d >> 8) & 255] +
                  "-" +
                  a[(d >> 16) & 255] +
                  a[(d >> 24) & 255] +
                  a[255 & e] +
                  a[(e >> 8) & 255] +
                  a[(e >> 16) & 255] +
                  a[(e >> 24) & 255]
                );
              },
              u = function () {
                var a = "";
                return (
                  (a = s("ecster_id") ? s("ecster_id") : t()),
                  r("ecster_id", a, 365),
                  a
                );
              },
              v = function (a) {
                return a !== decodeURIComponent(a) ? a : encodeURIComponent(a);
              };
            (c._start = function (a) {
              var b;
              if (
                ((a.orderReference = a.cartKey),
                (c.checkoutLocked = !0),
                (c.checkoutUrl = k()),
                (c.config = a),
                !a.orderReference)
              ) {
                var h = "EcsterPay.start config error: cartKey is missing ";
                throw h;
              }
              if (!a.shopTermsUrl) {
                var l =
                  "EcsterPay.start config error: shopTermsUrl is missing ";
                throw l;
              }
              if (!a.shopTermsUrl.match(/^http(s)?:\/\//i)) {
                var m =
                  "EcsterPay.start config error: shopTermsUrl has incorrect format: must start with http or https";
                throw m;
              }
              if (
                !(
                  a.showPaymentResult ||
                  (a.onPaymentSuccess &&
                    "function" == typeof a.onPaymentSuccess)
                )
              ) {
                var o =
                  "EcsterPay.start config error: showPaymentResult must be true or onPaymentSuccess must be a function";
                throw o;
              }
              (a.shopTermsUrl = v(a.shopTermsUrl)),
                (b = { config: a, clientId: u() }),
                q(b),
                "function" == typeof a.onCheckoutStartInit &&
                  a.onCheckoutStartInit(),
                "function" == typeof a.onChangedDeliveryMethod &&
                  i.addHandler("store-changed-delivery-method", function (b) {
                    a.onChangedDeliveryMethod(b);
                  }),
                "function" == typeof a.onChangedDeliveryAddress &&
                  i.addHandler("store-changed-delivery-address", function (b) {
                    a.onChangedDeliveryAddress(b);
                  }),
                "function" == typeof a.onChangedContactInfo &&
                  i.addHandler("store-changed-contact-info", function (b) {
                    a.onChangedContactInfo(b);
                  }),
                "function" == typeof a.onPaymentSuccess &&
                  i.addHandler("store-payment-success", function (b) {
                    a.onPaymentSuccess(b);
                  }),
                "function" == typeof a.onPaymentDenied &&
                  i.addHandler("store-payment-denied", function (b) {
                    a.onPaymentDenied(b);
                  }),
                "function" == typeof a.onPaymentFailure &&
                  i.addHandler("store-payment-failure", function (b) {
                    a.onPaymentFailure(b);
                  }),
                "function" == typeof a.onCustomerAuthenticated &&
                  i.addHandler("store-customer-authenticated", function (b) {
                    a.onCustomerAuthenticated(b);
                  }),
                "function" == typeof a.onPaymentMethodSelected &&
                  i.addHandler("store-payment-method-selected", function (b) {
                    a.onPaymentMethodSelected(b);
                  }),
                "function" == typeof a.onBeforeSubmit
                  ? i.addHandler("ep-before-submit", function (b) {
                      var c = !1,
                        f = new setTimeout(function () {
                          (c = !0),
                            i.sendMessage("checkout-before-submit", {
                              proceed: !0,
                            }),
                            j.error(
                              "onBeforeSubmit - Timeout reached before storeCallback was executed!",
                              "EP",
                              b
                            );
                        }, 1e4),
                        g = function () {
                          var a =
                              !(
                                arguments.length > 0 && void 0 !== arguments[0]
                              ) || arguments[0],
                            b =
                              arguments.length > 1 && void 0 !== arguments[1]
                                ? arguments[1]
                                : {};
                          clearTimeout(f),
                            c ||
                              (i.sendMessage(
                                "checkout-before-submit",
                                e({}, b, { proceed: a })
                              ),
                              d(a) !== Boolean);
                        };
                      (window.EcsterPay.storeCallback = g),
                        a.onBeforeSubmit(b, g);
                    })
                  : i.addHandler("ep-before-submit", function (a) {
                      i.sendMessage("checkout-before-submit", { proceed: !0 });
                    }),
                i.addHandler("store-start-success", function (b) {
                  (c.checkoutLocked = !1),
                    n(),
                    "function" == typeof a.onCheckoutStartSuccess &&
                      a.onCheckoutStartSuccess(b);
                }),
                i.addHandler("store-start-failure", function (b) {
                  (c.checkoutLocked = !1),
                    "function" == typeof a.onCheckoutStartFailure &&
                      a.onCheckoutStartFailure(b);
                }),
                i.addHandler("store-update-success", function (a) {
                  (c.checkoutLocked = !1),
                    "function" == typeof c.config.onCheckoutUpdateSuccess &&
                      c.config.onCheckoutUpdateSuccess(a);
                }),
                i.addHandler("store-update-failure", function (b) {
                  (c.checkoutLocked = !1),
                    "function" == typeof a.onCheckoutUpdateFailure &&
                      a.onCheckoutUpdateFailure(b);
                }),
                i.addHandler("ep-open-bank-id", function (a) {
                  window.top.location.href = a.url;
                }),
                i.addHandler("ep-scroll-to-top-iframe", function () {
                  window.scrollTo(0, g.offsetTop);
                }),
                i.addHandler("checkout-cancel-swish-polling", function () {
                  i.sendMessage("checkout-cancel-swish-polling");
                }),
                i.addHandler("ep-start-swish-app", function (a) {
                  window.top.location.href =
                    "swish://paymentrequest?token=" +
                    a.token +
                    "&callbackurl=null";
                }),
                (f = !0);
            }),
              (c._getUrl = function (a) {
                var b = k();
                return (
                  (b += "/?refid=" + a.cartKey),
                  (b += "&cart=" + a.showCart),
                  (b += "&showDelivery=" + a.showDelivery),
                  (b += a.showCustomerData ? "&customer=true" : ""),
                  (b += "&shopterms=" + v(a.shopTermsUrl))
                );
              }),
              (c._initUpdateCart = function (a) {
                if (f) {
                  if (c.checkoutLocked) {
                    var b = "Checkout is updating";
                    throw b;
                  }
                  return (
                    "function" == typeof c.config.onCheckoutUpdateInit &&
                      c.config.onCheckoutUpdateInit(),
                    (c.checkoutLocked = !0),
                    i.sendMessage("checkout-lock"),
                    function (b) {
                      if (b === a) {
                        var c = "Cannot use old key";
                        throw c;
                      }
                      i.sendMessage("checkout-update-order", b);
                    }
                  );
                }
              }),
              (c._isStarted = function () {
                return f;
              });
          },
          m = new l(),
          n = [k() + "/locales/sv.json", k() + "/locales/en.json"];
        document.body ? h() : window.addEventListener("DOMContentLoaded", h),
          (window.EcsterPay = {
            start: m._start,
            getUrl: m._getUrl,
            getNewWindowUrl: function (a) {
              return m._getUrl(a);
            },
            initUpdateCart: m._initUpdateCart,
            updateCart: function (a) {
              return m._initUpdateCart(a);
            },
            isStarted: m._isStarted,
          }),
          (b.exports = void 0);
      },
      { "./EcsterPayCommunicator": 2, "@ecster/logging": 5 },
    ],
    2: [
      function (a, b, c) {
        "use strict";
        function d() {
          if (null !== k)
            throw new Error(
              "Cannot instantiate more than one CheckoutCommunicator, use getInstance()!"
            );
          this.initialize();
        }
        String.prototype.startsWith ||
          Object.defineProperty(String.prototype, "startsWith", {
            value: function (a, b) {
              var c = b > 0 ? 0 | b : 0;
              return this.substring(c, c + a.length) === a;
            },
          });
        var e,
          f,
          g,
          h,
          i = a("@ecster/ecster-messaging/lib/PostMessage"),
          j = a("./messageValidatorEcsterPay"),
          k = null,
          l = !1,
          m = !1;
        (d.prototype = {
          initialize: function () {
            if (l)
              throw new Error(
                "Cannot initialize CheckoutCommunicator more than once, use getInstance()!"
              );
            (this.initialized = !0),
              (this.fullscreen = !1),
              (this.checkoutStarted = !1);
          },
          sendMessage: function (a, b) {
            if (j(a)) {
              var c = a.startsWith("fullscreen-"),
                d = (a.startsWith("checkout-"), e),
                i = f,
                k = { msgKey: a, data: b || "no-data" };
              c && ((d = g), (i = h)),
                d && i && d.postMessage(JSON.stringify(k), i);
            }
          },
          addHandler: function (a, b) {
            i.addHandler(a, b);
          },
          startFullscreenCommunicator: function (a, b) {
            (this.fullscreen = !0),
              (g = a),
              (h = b),
              this.sendMessage("fullscreen-start-communication");
          },
          startCommunication: function (a, b, c) {
            var d = this;
            (e = a),
              (f = b),
              i.addHandler("ep-ready", function (a) {
                (m = !0), i.removeHandler("ep-ready");
              }),
              (d.checkoutStartInterval = setInterval(function () {
                m
                  ? (d.sendMessage("checkout-web-shop-data", c),
                    (m = !1),
                    clearInterval(d.checkoutStartInterval))
                  : d.sendMessage("checkout-start");
              }, 5));
          },
        }),
          (d.getInstance = function () {
            return null === k && (k = new d()), k;
          }),
          (b.exports = d.getInstance());
      },
      {
        "./messageValidatorEcsterPay": 3,
        "@ecster/ecster-messaging/lib/PostMessage": 4,
      },
    ],
    3: [
      function (a, b, c) {
        "use strict";
        String.prototype.startsWith ||
          Object.defineProperty(String.prototype, "startsWith", {
            value: function (a, b) {
              var c = b > 0 ? 0 | b : 0;
              return this.substring(c, c + a.length) === a;
            },
          }),
          (b.exports = function (a) {
            return !(
              !a.startsWith("fullscreen-") && !a.startsWith("checkout-")
            );
          });
      },
      {},
    ],
    4: [
      function (a, b, c) {
        "use strict";
        function d() {
          if (null !== e)
            throw new Error(
              "Cannot instantiate more than one PostMessage, use getInstance()!"
            );
          this.init();
        }
        var e = null,
          f = !1;
        (d.prototype = {
          init: function () {
            var a = this;
            if (((a.handlers = {}), f))
              throw new Error(
                "Cannot init PostMessage more than once, use getInstance()!"
              );
            (f = !0),
              window.addEventListener("message", function (b) {
                try {
                  var c = JSON.parse(b.data);
                  if (c.msgKey)
                    for (var d in a.handlers)
                      a.handlers.hasOwnProperty(d) &&
                        d === c.msgKey &&
                        "function" == typeof a.handlers[d] &&
                        a.handlers[d](c.data, b);
                } catch (e) {}
              }),
              (a.addHandler = function (b, c) {
                a.handlers[b] = c;
              }),
              (a.removeHandler = function (b) {
                a.handlers[b] && (a.handlers[b] = void 0);
              });
          },
        }),
          (d.getInstance = function () {
            return null === e && (e = new d()), e;
          }),
          (b.exports = d.getInstance());
      },
      {},
    ],
    5: [
      function (a, b, c) {
        "use strict";
        b.exports = { ServerLog: a("./lib/ServerLog") };
      },
      { "./lib/ServerLog": 6 },
    ],
    6: [
      function (a, b, c) {
        "use strict";
        var d = a("@ecster/net/lib/Ajax"),
          e = function (a, b, c, e, f) {
            var g,
              h = "string" == typeof e ? { info: e } : e;
            try {
              (h.meta = {}),
                (h.meta.origin = c),
                (h.meta.description = f),
                (h.meta.severity = a),
                (g = {
                  operation: "".concat(c, " [").concat(a, "] ").concat(b),
                  data: JSON.stringify(h, null, 4),
                }),
                d.post({ url: "/rest/log/v1" }, g);
            } catch (i) {}
          },
          f = function (a, b, c, d) {
            e("info", a, b, c, d);
          },
          g = function (a, b, c, d) {
            e("warn", a, b, c, d);
          },
          h = function (a, b, c, d) {
            e("err", a, b, c, d);
          };
        b.exports = { info: f, warning: g, error: h };
      },
      { "@ecster/net/lib/Ajax": 9 },
    ],
    7: [
      function (a, b, c) {
        function d() {
          throw new Error("setTimeout has not been defined");
        }
        function e() {
          throw new Error("clearTimeout has not been defined");
        }
        function f(a) {
          if (l === setTimeout) return setTimeout(a, 0);
          if ((l === d || !l) && setTimeout)
            return (l = setTimeout), setTimeout(a, 0);
          try {
            return l(a, 0);
          } catch (b) {
            try {
              return l.call(null, a, 0);
            } catch (b) {
              return l.call(this, a, 0);
            }
          }
        }
        function g(a) {
          if (m === clearTimeout) return clearTimeout(a);
          if ((m === e || !m) && clearTimeout)
            return (m = clearTimeout), clearTimeout(a);
          try {
            return m(a);
          } catch (b) {
            try {
              return m.call(null, a);
            } catch (b) {
              return m.call(this, a);
            }
          }
        }
        function h() {
          q &&
            o &&
            ((q = !1),
            o.length ? (p = o.concat(p)) : (r = -1),
            p.length && i());
        }
        function i() {
          if (!q) {
            var a = f(h);
            q = !0;
            for (var b = p.length; b; ) {
              for (o = p, p = []; ++r < b; ) o && o[r].run();
              (r = -1), (b = p.length);
            }
            (o = null), (q = !1), g(a);
          }
        }
        function j(a, b) {
          (this.fun = a), (this.array = b);
        }
        function k() {}
        var l,
          m,
          n = (b.exports = {});
        !(function () {
          try {
            l = "function" == typeof setTimeout ? setTimeout : d;
          } catch (a) {
            l = d;
          }
          try {
            m = "function" == typeof clearTimeout ? clearTimeout : e;
          } catch (a) {
            m = e;
          }
        })();
        var o,
          p = [],
          q = !1,
          r = -1;
        (n.nextTick = function (a) {
          var b = new Array(arguments.length - 1);
          if (arguments.length > 1)
            for (var c = 1; c < arguments.length; c++) b[c - 1] = arguments[c];
          p.push(new j(a, b)), 1 !== p.length || q || f(i);
        }),
          (j.prototype.run = function () {
            this.fun.apply(null, this.array);
          }),
          (n.title = "browser"),
          (n.browser = !0),
          (n.env = {}),
          (n.argv = []),
          (n.version = ""),
          (n.versions = {}),
          (n.on = k),
          (n.addListener = k),
          (n.once = k),
          (n.off = k),
          (n.removeListener = k),
          (n.removeAllListeners = k),
          (n.emit = k),
          (n.prependListener = k),
          (n.prependOnceListener = k),
          (n.listeners = function (a) {
            return [];
          }),
          (n.binding = function (a) {
            throw new Error("process.binding is not supported");
          }),
          (n.cwd = function () {
            return "/";
          }),
          (n.chdir = function (a) {
            throw new Error("process.chdir is not supported");
          }),
          (n.umask = function () {
            return 0;
          });
      },
      {},
    ],
    8: [
      function (a, b, c) {
        (function (b, d) {
          function e(a, b) {
            (this._id = a), (this._clearFn = b);
          }
          var f = a("process/browser.js").nextTick,
            g = Function.prototype.apply,
            h = Array.prototype.slice,
            i = {},
            j = 0;
          (c.setTimeout = function () {
            return new e(g.call(setTimeout, window, arguments), clearTimeout);
          }),
            (c.setInterval = function () {
              return new e(
                g.call(setInterval, window, arguments),
                clearInterval
              );
            }),
            (c.clearTimeout = c.clearInterval =
              function (a) {
                a.close();
              }),
            (e.prototype.unref = e.prototype.ref = function () {}),
            (e.prototype.close = function () {
              this._clearFn.call(window, this._id);
            }),
            (c.enroll = function (a, b) {
              clearTimeout(a._idleTimeoutId), (a._idleTimeout = b);
            }),
            (c.unenroll = function (a) {
              clearTimeout(a._idleTimeoutId), (a._idleTimeout = -1);
            }),
            (c._unrefActive = c.active =
              function (a) {
                clearTimeout(a._idleTimeoutId);
                var b = a._idleTimeout;
                b >= 0 &&
                  (a._idleTimeoutId = setTimeout(function () {
                    a._onTimeout && a._onTimeout();
                  }, b));
              }),
            (c.setImmediate =
              "function" == typeof b
                ? b
                : function (a) {
                    var b = j++,
                      d = !(arguments.length < 2) && h.call(arguments, 1);
                    return (
                      (i[b] = !0),
                      f(function () {
                        i[b] &&
                          (d ? a.apply(null, d) : a.call(null),
                          c.clearImmediate(b));
                      }),
                      b
                    );
                  }),
            (c.clearImmediate =
              "function" == typeof d
                ? d
                : function (a) {
                    delete i[a];
                  });
        }.call(this, a("timers").setImmediate, a("timers").clearImmediate));
      },
      { "process/browser.js": 7, timers: 8 },
    ],
    9: [
      function (a, b, c) {
        "use strict";
        var d,
          e,
          f = a("./v2/KeyValueStorage"),
          g = "sessionKey",
          h = "origin",
          i = a("qwest"),
          j = "X-ECSTER-session",
          k = "X-ECSTER-origin",
          l = function (a) {
            if (!a) throw "error: config undefined in ecster-net/lib/Ajax";
            if (!a.url)
              throw "error: config.url undefined in ecster-net/lib/Ajax";
            e &&
              (a.url = ""
                .concat(e.replace(/\/$/, ""), "/")
                .concat(a.url.replace(/^\//, ""))),
              a.dataType || (a.dataType = "json");
          },
          m = function (a) {
            var b = f.keyValueStorage.getItem(g),
              c = !1,
              d = !1,
              e = f.keyValueStorage.getItem(h),
              i = {};
            if (
              (void 0 !== b && "undefined" !== b && "" !== b && (i[j] = b),
              e && (i[k] = e),
              a.headers)
            )
              for (var l in a.headers)
                a.headers.hasOwnProperty(l) &&
                  ((i[l] = a.headers[l]),
                  (c = c || "content-type" === l.toLowerCase()),
                  (d = d || "accept" === l.toLowerCase()));
            if (!c && a.dataType)
              switch (a.dataType) {
                case "application/json":
                case "json":
                  (i["Content-Type"] = "application/json"), (c = !0);
                  break;
                case "text/plain":
                case "text":
                  (i["Content-Type"] = "text/plain"), (c = !0);
                  break;
                case "text/html":
                  (i["Content-Type"] = "text/html"), (c = !0);
              }
            return (
              !c &&
                a.contentType &&
                ((i["Content-Type"] = a.contentType), (c = !0)),
              !d && a.accept && (i.Accept = a.accept),
              d || (i.Accept = "application/json"),
              i
            );
          },
          n = function (a) {
            l(a);
            var b = i.get(a.url, null, { dataType: a.dataType, headers: m(a) });
            return (a.errorHandler || d) && b["catch"](a.errorHandler || d), b;
          },
          o = function (a, b) {
            l(a);
            var c = i.post(a.url, b, { dataType: a.dataType, headers: m(a) });
            return (a.errorHandler || d) && c["catch"](a.errorHandler || d), c;
          },
          p = function (a, b) {
            l(a);
            var c = i.put(a.url, b, { dataType: a.dataType, headers: m(a) });
            return (a.errorHandler || d) && c["catch"](a.errorHandler || d), c;
          },
          q = function (a, b) {
            l(a);
            var c = i["delete"](a.url, b, {
              dataType: a.dataType,
              headers: m(a),
            });
            return (a.errorHandler || d) && c["catch"](a.errorHandler || d), c;
          };
        b.exports = {
          get: n,
          post: o,
          put: p,
          delete: q,
          setErrorHandler: function (a) {
            d = a;
          },
          setBaseUrl: function (a) {
            e = a;
          },
          getBaseUrl: function () {
            return e;
          },
        };
      },
      { "./v2/KeyValueStorage": 10, qwest: 13 },
    ],
    10: [
      function (a, b, c) {
        "use strict";
        Object.defineProperty(c, "__esModule", { value: !0 }),
          (c.keyValueStorage = void 0),
          (window.ecKeyValueStorage = window.ecKeyValueStorage || {});
        var d = function (a) {
            var b;
            try {
              var c = "__storage_test__";
              return (b = window[a]), b.setItem(c, c), b.removeItem(c), !0;
            } catch (d) {
              return (
                d instanceof DOMException &&
                (22 === d.code ||
                  1014 === d.code ||
                  "QuotaExceededError" === d.name ||
                  "NS_ERROR_DOM_QUOTA_REACHED" === d.name) &&
                0 !== b.length
              );
            }
          },
          e = {
            getItem: function (a) {
              return window.ecKeyValueStorage[a];
            },
            setItem: function (a, b) {
              return (window.ecKeyValueStorage[a] = b);
            },
            removeItem: function (a) {
              return delete window.ecKeyValueStorage[a];
            },
          },
          f = function () {
            return d("sessionStorage") ? window.sessionStorage : e;
          },
          g = function (a, b) {
            f().setItem(a, b);
          },
          h = function (a) {
            return f().getItem(a);
          },
          i = function (a) {
            f().removeItem(a);
          },
          j = { setItem: g, getItem: h, removeItem: i };
        c.keyValueStorage = j;
      },
      {},
    ],
    11: [
      function (a, b, c) {
        !(function (a) {
          "use strict";
          var c = function (a) {
            var b = function (a, b, c) {
                (c =
                  "function" == typeof c
                    ? c()
                    : null === c
                    ? ""
                    : void 0 === c
                    ? ""
                    : c),
                  (a[a.length] =
                    encodeURIComponent(b) + "=" + encodeURIComponent(c));
              },
              c = function (a, d, e) {
                var f, g, h;
                if ("[object Array]" === Object.prototype.toString.call(d))
                  for (f = 0, g = d.length; f < g; f++)
                    c(
                      a + "[" + ("object" == typeof d[f] ? f : "") + "]",
                      d[f],
                      e
                    );
                else if (d && "[object Object]" === d.toString())
                  for (h in d)
                    d.hasOwnProperty(h) &&
                      (a ? c(a + "[" + h + "]", d[h], e, b) : c(h, d[h], e, b));
                else if (a) b(e, a, d);
                else for (h in d) b(e, h, d[h]);
                return e;
              };
            return c("", a, []).join("&").replace(/%20/g, "+");
          };
          "object" == typeof b && "object" == typeof b.exports
            ? (b.exports = c)
            : "function" == typeof define && define.amd
            ? define([], function () {
                return c;
              })
            : (a.param = c);
        })(this);
      },
      {},
    ],
    12: [
      function (a, b, c) {
        (function (a, c) {
          !(function (a, c) {
            "function" == typeof define && define.amd
              ? define([], c)
              : "object" == typeof b && b.exports
              ? (b.exports = c())
              : (a.pinkySwear = c());
          })(this, function () {
            function b(a) {
              return "function" == typeof a;
            }
            function d(a) {
              return "object" == typeof a;
            }
            function e(b) {
              "undefined" != typeof c
                ? c(b)
                : "undefined" != typeof a && a.nextTick
                ? a.nextTick(b)
                : setTimeout(b, 0);
            }
            var f;
            return function g(a) {
              var c,
                h = [],
                i = [],
                j = function (a, b) {
                  return (
                    null == c &&
                      null != a &&
                      ((c = a),
                      (h = b),
                      i.length &&
                        e(function () {
                          for (var a = 0; a < i.length; a++) i[a]();
                        })),
                    c
                  );
                };
              return (
                (j.then = function (j, k) {
                  var l = g(a),
                    m = function () {
                      function a(c) {
                        var e,
                          g = 0;
                        try {
                          if (c && (d(c) || b(c)) && b((e = c.then))) {
                            if (c === l) throw new TypeError();
                            e.call(
                              c,
                              function () {
                                g++ || a.apply(f, arguments);
                              },
                              function (a) {
                                g++ || l(!1, [a]);
                              }
                            );
                          } else l(!0, arguments);
                        } catch (h) {
                          g++ || l(!1, [h]);
                        }
                      }
                      try {
                        var e = c ? j : k;
                        b(e) ? a(e.apply(f, h || [])) : l(c, h);
                      } catch (g) {
                        l(!1, [g]);
                      }
                    };
                  return null != c ? e(m) : i.push(m), l;
                }),
                a && (j = a(j)),
                j
              );
            };
          });
        }.call(this, a("_process"), a("timers").setImmediate));
      },
      { _process: 7, timers: 8 },
    ],
    13: [
      function (a, b, c) {
        b.exports = (function () {
          var b = "undefined" != typeof window ? window : self,
            c = a("pinkyswear"),
            d = a("jquery-param"),
            e = {},
            f = "json",
            g = "post",
            h = null,
            i = 0,
            j = [],
            k = b.XMLHttpRequest
              ? function () {
                  return new b.XMLHttpRequest();
                }
              : function () {
                  return new ActiveXObject("Microsoft.XMLHTTP");
                },
            l = "" === k().responseType,
            m = function (a, m, n, o, p) {
              (a = a.toUpperCase()),
                (n = void 0 === n ? null : n),
                (o = o || {});
              for (var q in e)
                if (!(q in o))
                  if ("object" == typeof e[q] && "object" == typeof o[q])
                    for (var r in e[q]) o[q][r] = e[q][r];
                  else o[q] = e[q];
              var s,
                t,
                u,
                v,
                w,
                x = !1,
                y = !1,
                z = !1,
                A = 0,
                B = {},
                C = {
                  text: "*/*",
                  xml: "text/xml",
                  json: "application/json",
                  post: "application/x-www-form-urlencoded",
                  document: "text/html",
                },
                D = {
                  text: "*/*",
                  xml: "application/xml; q=1.0, text/xml; q=0.8, */*; q=0.1",
                  json: "application/json; q=1.0, text/*; q=0.8, */*; q=0.1",
                },
                E = !1,
                F = c(function (c) {
                  return (
                    (c.abort = function () {
                      z ||
                        (t && 4 != t.readyState && t.abort(),
                        E && (--i, (E = !1)),
                        (z = !0));
                    }),
                    (c.send = function () {
                      if (!E) {
                        if (i == h) return void j.push(c);
                        if (z) return void (j.length && j.shift().send());
                        if (
                          (++i,
                          (E = !0),
                          (t = k()),
                          s &&
                            ("withCredentials" in t ||
                              !b.XDomainRequest ||
                              ((t = new XDomainRequest()),
                              (y = !0),
                              "GET" != a && "POST" != a && (a = "POST"))),
                          y
                            ? t.open(a, m)
                            : (t.open(a, m, o.async, o.user, o.password),
                              l &&
                                o.async &&
                                (t.withCredentials = o.withCredentials)),
                          !y)
                        )
                          for (var d in B) B[d] && t.setRequestHeader(d, B[d]);
                        if (l && "auto" != o.responseType)
                          try {
                            (t.responseType = o.responseType),
                              (x = t.responseType == o.responseType);
                          } catch (e) {}
                        l || y
                          ? ((t.onload = G),
                            (t.onerror = H),
                            y && (t.onprogress = function () {}))
                          : (t.onreadystatechange = function () {
                              4 == t.readyState && G();
                            }),
                          o.async
                            ? "timeout" in t
                              ? ((t.timeout = o.timeout), (t.ontimeout = I))
                              : (u = setTimeout(I, o.timeout))
                            : y && (t.ontimeout = function () {}),
                          "auto" != o.responseType &&
                            "overrideMimeType" in t &&
                            t.overrideMimeType(C[o.responseType]),
                          p && p(t),
                          y
                            ? setTimeout(function () {
                                t.send("GET" != a ? n : null);
                              }, 0)
                            : t.send("GET" != a ? n : null);
                      }
                    }),
                    c
                  );
                }),
                G = function () {
                  var a;
                  if (
                    ((E = !1),
                    clearTimeout(u),
                    j.length && j.shift().send(),
                    !z)
                  ) {
                    --i;
                    try {
                      if (x) {
                        if ("response" in t && null === t.response)
                          throw "The request response is empty";
                        w = t.response;
                      } else {
                        if (((a = o.responseType), "auto" == a))
                          if (y) a = f;
                          else {
                            var c = t.getResponseHeader("Content-Type") || "";
                            a =
                              c.indexOf(C.json) > -1
                                ? "json"
                                : c.indexOf(C.xml) > -1
                                ? "xml"
                                : "text";
                          }
                        switch (a) {
                          case "json":
                            if (t.responseText.length)
                              try {
                                w =
                                  "JSON" in b
                                    ? JSON.parse(t.responseText)
                                    : new Function(
                                        "return (" + t.responseText + ")"
                                      )();
                              } catch (d) {
                                throw "Error while parsing JSON body : " + d;
                              }
                            break;
                          case "xml":
                            try {
                              b.DOMParser
                                ? (w = new DOMParser().parseFromString(
                                    t.responseText,
                                    "text/xml"
                                  ))
                                : ((w = new ActiveXObject("Microsoft.XMLDOM")),
                                  (w.async = "false"),
                                  w.loadXML(t.responseText));
                            } catch (d) {
                              w = void 0;
                            }
                            if (
                              !w ||
                              !w.documentElement ||
                              w.getElementsByTagName("parsererror").length
                            )
                              throw "Invalid XML";
                            break;
                          default:
                            w = t.responseText;
                        }
                      }
                      if ("status" in t && !/^2|1223/.test(t.status))
                        throw t.status + " (" + t.statusText + ")";
                      F(!0, [t, w]);
                    } catch (d) {
                      F(!1, [d, t, w]);
                    }
                  }
                },
                H = function (a) {
                  z ||
                    ((a = "string" == typeof a ? a : "Connection aborted"),
                    F.abort(),
                    F(!1, [new Error(a), t, null]));
                },
                I = function () {
                  z ||
                    (o.attempts && ++A == o.attempts
                      ? H("Timeout (" + m + ")")
                      : (t.abort(), (E = !1), F.send()));
                };
              if (
                ((o.async = !("async" in o) || !!o.async),
                (o.cache = "cache" in o && !!o.cache),
                (o.dataType = "dataType" in o ? o.dataType.toLowerCase() : g),
                (o.responseType =
                  "responseType" in o ? o.responseType.toLowerCase() : "auto"),
                (o.user = o.user || ""),
                (o.password = o.password || ""),
                (o.withCredentials = !!o.withCredentials),
                (o.timeout = "timeout" in o ? parseInt(o.timeout, 10) : 3e4),
                (o.attempts = "attempts" in o ? parseInt(o.attempts, 10) : 1),
                (v = m.match(/\/\/(.+?)\//)),
                (s = v && !!v[1] && v[1] != location.host),
                "ArrayBuffer" in b && n instanceof ArrayBuffer
                  ? (o.dataType = "arraybuffer")
                  : "Blob" in b && n instanceof Blob
                  ? (o.dataType = "blob")
                  : "Document" in b && n instanceof Document
                  ? (o.dataType = "document")
                  : "FormData" in b &&
                    n instanceof FormData &&
                    (o.dataType = "formdata"),
                null !== n)
              )
                switch (o.dataType) {
                  case "json":
                    n = JSON.stringify(n);
                    break;
                  case "post":
                  case "queryString":
                    n = d(n);
                }
              if (o.headers) {
                var J = function (a, b, c) {
                  return b + c.toUpperCase();
                };
                for (v in o.headers)
                  B[v.replace(/(^|-)([^-])/g, J)] = o.headers[v];
              }
              return (
                "Content-Type" in B ||
                  "GET" == a ||
                  (o.dataType in C &&
                    C[o.dataType] &&
                    (B["Content-Type"] = C[o.dataType])),
                B.Accept ||
                  (B.Accept = o.responseType in D ? D[o.responseType] : "*/*"),
                s ||
                  "X-Requested-With" in B ||
                  (B["X-Requested-With"] = "XMLHttpRequest"),
                o.cache ||
                  "Cache-Control" in B ||
                  (B["Cache-Control"] = "no-cache"),
                ("GET" != a && "queryString" != o.dataType) ||
                  !n ||
                  "string" != typeof n ||
                  (m += (/\?/.test(m) ? "&" : "?") + n),
                o.async && F.send(),
                F
              );
            },
            n = function (a) {
              var b = [],
                d = 0,
                e = [];
              return c(function (c) {
                var f = -1,
                  g = function (a) {
                    return function (g, h, i, j) {
                      var k = ++f;
                      return (
                        ++d,
                        b.push(
                          m(a, c.base + g, h, i, j).then(
                            function (a, b) {
                              (e[k] = arguments),
                                --d || c(!0, 1 == e.length ? e[0] : [e]);
                            },
                            function () {
                              c(!1, arguments);
                            }
                          )
                        ),
                        c
                      );
                    };
                  };
                (c.get = g("GET")),
                  (c.post = g("POST")),
                  (c.put = g("PUT")),
                  (c["delete"] = g("DELETE")),
                  (c["catch"] = function (a) {
                    return c.then(null, a);
                  }),
                  (c.complete = function (a) {
                    var b = function () {
                      a();
                    };
                    return c.then(b, b);
                  }),
                  (c.map = function (a, b, c, d, e) {
                    return g(a.toUpperCase()).call(this, b, c, d, e);
                  });
                for (var h in a) h in c || (c[h] = a[h]);
                return (
                  (c.send = function () {
                    for (var a = 0, d = b.length; a < d; ++a) b[a].send();
                    return c;
                  }),
                  (c.abort = function () {
                    for (var a = 0, d = b.length; a < d; ++a) b[a].abort();
                    return c;
                  }),
                  c
                );
              });
            },
            o = {
              base: "",
              get: function () {
                return n(o).get.apply(this, arguments);
              },
              post: function () {
                return n(o).post.apply(this, arguments);
              },
              put: function () {
                return n(o).put.apply(this, arguments);
              },
              delete: function () {
                return n(o)["delete"].apply(this, arguments);
              },
              map: function () {
                return n(o).map.apply(this, arguments);
              },
              xhr2: l,
              limit: function (a) {
                return (h = a), o;
              },
              setDefaultOptions: function (a) {
                return (e = a), o;
              },
              setDefaultXdrResponseType: function (a) {
                return (f = a.toLowerCase()), o;
              },
              setDefaultDataType: function (a) {
                return (g = a.toLowerCase()), o;
              },
              getOpenRequests: function () {
                return i;
              },
            };
          return o;
        })();
      },
      { "jquery-param": 11, pinkyswear: 12 },
    ],
  },
  {},
  [1]
);
